import { recordEvent } from '../repositories/storyRepository';
import { statusEvent } from './userEvents';

export interface StoryBookmarkTarget {
  id: string;
  is_flagged: boolean;
}

export async function toggleStoryBookmark(
  story: StoryBookmarkTarget,
  onUpdate: () => void,
): Promise<void> {
  const previous = story.is_flagged;
  const next = !previous;
  story.is_flagged = next;
  onUpdate();
  try {
    await recordEvent(story.id, statusEvent('flag', next));
  } catch {
    story.is_flagged = previous;
    onUpdate();
  }
}
